import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import { CalendarService } from '../../../services/calendar/calendar.service';
declare var $: any;
import * as moment from 'moment';
import { Filters } from 'src/app/models/filters/filters';
import { CategoriesService } from 'src/app/services/categories/categories.service';
import {
  Category,
  CategoryTree,
  Service,
} from 'src/app/models/categoryTree/category-tree';
import { LabelInfo, Reservation } from 'src/app/models/reservation/reservation';
import { Label } from 'src/app/models/label/label';
import { LabelService } from 'src/app/services/label/label.service';
import { Cart, CartItems } from 'src/app/models/cart/cart';
import { DepartmentService } from '../../../services/department/department.service';
import { Department } from '../../../models/department/department';
import { Router } from '@angular/router';
import { AdminServiceService } from 'src/app/services/admin/admin-service.service';
import { AccountService } from 'src/app/services/account/account.service';
import { Observable, Subject } from 'rxjs';
import { EventRenderedArgs, EventSettingsModel } from '@syncfusion/ej2-angular-schedule';
import { FiltersComponent } from 'src/app/filters/filters.component';
@Component({
  selector: 'app-calendar-report',
  templateUrl: './calendar-report.component.html',
  styleUrls: ['./calendar-report.component.scss'],
})
export class CalendarReportComponent implements OnInit, AfterViewInit {
  account: any = localStorage.getItem('HechRomeoAccount');
  isUser: boolean = localStorage.getItem('HechRomeoRole') === 'User' ? true : false;
  events: any = [];
  services: any = [];
  filter = undefined;
  calendar;
  previousDate;
  previousEvent;
  eventSelected;
  currentLanguage = localStorage.getItem('language');
  reservationToCancel = {
    reservationid: undefined,
    servicedate: undefined,
    servicetime: undefined,
    email: undefined,
    serviceid: undefined,
  };
  tzoffset = new Date().getTimezoneOffset() * 60000;

  filters: Filters = new Filters();
  newFilters: Filters = new Filters();
  categoryTree: CategoryTree;
  allCategories: Category[] = [];
  allServices: Service[] = [];
  cartServices: Service[] = [];
  cartServicesNotActivated: Service[] = [];
  newReservation: Reservation = new Reservation();
  newCart: Cart = new Cart();
  selectedService;
  selectedLabel;
  allLabels: Label[] = [];
  availableLabels: Label[] = [];
  categoriesSelect = {
    selectedCategory0: undefined,
    selectedCategory1: undefined,
    selectedCategory2: undefined,
    selectedCategory3: undefined,
    categoryObj0: { categories: [] },
    categoryObj1: { categories: [] },
    categoryObj2: { categories: [] },
    categoryObj3: { categories: [] },
    currentServiceList: [],
    selectedServiceInList: undefined,
  };
  filterDate = { from: '', to: '' };
  newFilterDate;
  newCategoriesSelect;
  hideCalendar = false;
  cartLabelsList = [];
  isDetailsService: boolean = false;
  listSearchRequest = [];
  listSearchRequestShopping = [];
  totalSearchRequest: number = 0;
  totalFee: number = 0;
  totalServices: number = 0;
  totalNumber: number = 0;
  timeslots = [];
  selectedDate;
  currentCurrency = null;
  eventSettings: EventSettingsModel = {
    dataSource: []
  };

  allDepartments: Department[];
  lastEvSelected: any = undefined;
  vendorList = [];
  virtualCategories = [];
  monthView = false;

  eventsSubject: Subject<void> = new Subject<void>();

  viewDeleteReservation: boolean = false;

  @ViewChild('schedulerObj') schedulerObj: any;
  @ViewChild('filtersComponent') filtersComponent: FiltersComponent;

  constructor(
    private calendarService: CalendarService,
    private categoriesService: CategoriesService,
    private labelService: LabelService,
    private departmentService: DepartmentService,
    private router: Router,
    private adminService: AdminServiceService,
    public accountService: AccountService
  ) {
  }

  ngOnInit(): void {
    const that = this;
    this.listSearchRequest = [];
    this.listSearchRequestShopping = [];
    this.totalSearchRequest = 0;
    this.totalFee = 0;
    this.totalServices = 0;
    this.totalNumber = 0;
    this.newFilters.account = this.account;
    const calendarEl = document.getElementById('calendar-report');
    this.newCategoriesSelect = { ...this.categoriesSelect };
    this.newFilterDate = { ...this.filterDate };
    this.isDetailsService = false;
    if(this.accountService.isOnlyUser) {
      this.getLinkedVendors();
    } else {
      this.getVendorList(this.accountService.account);
      this.getAllCategories(this.accountService.account);
      this.getAllLabels();
      this.getAllDepartments();
    }

    this.eventSettings = {
      dataSource: []
    };
  }

  ngAfterViewInit() {
    this.schedulerObj.timeScale.enable = false;
    this.filtersComponent.filters.account = this.account;
    this.filtersComponent.isDetailsService = false;
    this.filtersComponent.viewDeleteReservation = false;
    this.filtersComponent.schedulerObj = this.schedulerObj;
    if (this.selectedDate) {
      let splittedDate = this.selectedDate.split('/');
      this.filtersComponent.selectedDate = new Date(splittedDate[1] + '-' + splittedDate[0] + '-' + splittedDate[2])
      this.filtersComponent.searchRequest();
    }
    this.getAccountCurrency();
    // this.searchRequest();

    // setInterval(() => {
    //   if (this.router.url === '/calendar') {
    //     this.searchRequest();
    //   }
    // }, 300000);
  }

  async getLinkedVendors(){
    const getLinkedVendors =  await this.accountService.getLinkedVendors(this.accountService.account) as Observable<any>;
        getLinkedVendors.subscribe( res => {
        const vendorAccount = res.users[0].account;
        this.getVendorList(vendorAccount);
        this.getAllCategories(vendorAccount);
        this.getAllLabels();
        this.getAllDepartments();
      });
  }

  getVendorList(account: string) {
    this.accountService
      .getVedorAccount(account)
      .subscribe((data) => {
        this.vendorList = data;
      });
  }

  // makeReservation() {
  //   if (this.selectedService.isadvanced) {
  //     this.newReservation.account = localStorage.getItem('HechRomeoAccount');
  //     this.newReservation.servicedate = new Date(
  //       this.newReservation.servicedate
  //     )
  //       .toISOString()
  //       .substring(0, 10)
  //       .split('-')
  //       .reverse()
  //       .join('/');
  //     this.newReservation.reservationdate = new Date()
  //       .toISOString()
  //       .substring(0, 10)
  //       .split('-')
  //       .reverse()
  //       .join('/');
  //     var d = new Date();
  //     var h = this.addZero(d.getHours());
  //     var m = this.addZero(d.getMinutes());
  //     this.newReservation.reservationtime = h + ':' + m;

  //     if (this.selectedLabel) {
  //       // this.newReservation.labelinfos.labelid = this.selectedLabel.id;
  //     } else {
  //       this.newReservation.labelinfos = undefined;
  //     }

  //     console.log(
  //       'risultati',
  //       $('#timeslots option:selected').map(function (a, item) {
  //         return item.value;
  //       })
  //     );

  //     let selectedIds = $('#timeslots option:selected').map(function (a, item) {
  //       return item.value;
  //     });
  //     let selectedSlots = [];
  //     for (let element of selectedIds) {
  //       let tempSlot = this.timeslots.find((obj) => obj.id == element);
  //       selectedSlots.push({
  //         timeslot: tempSlot.timeslottext,
  //         quantity: this.newReservation.quantity,
  //       });
  //     }

  //     let reservation = {
  //       account: this.selectedService.parentaccount,
  //       serviceid: this.newReservation.serviceid,
  //       servicedate: this.newReservation.servicedate,
  //       name: this.newReservation.name,
  //       lastname: this.newReservation.lastname,
  //       email: this.newReservation.email,
  //       transactionId: '',
  //       labelinfo: this.newReservation.labelinfos
  //         ? this.newReservation.labelinfos
  //         : null,
  //       slots: selectedSlots,
  //       isfrompartner: true,
  //       partner: localStorage.getItem('HechRomeoAccount'),
  //     };

  //     this.calendarService
  //       .advancedServicesMenagerReservation(reservation)
  //       .subscribe((data) => {
  //         this.resetReservation();
  //         this.searchRequest();
  //       });

  //     // this.calendarService
  //     //   .makeReservation(this.newReservation)
  //     //   .subscribe((data) => {
  //     //     this.resetReservation();
  //     //     this.searchRequest();
  //     //   });
  //   } else {
  //     console.log(this.selectedService);
  //     this.newReservation.account = this.selectedService.parentaccount;
  //     this.newReservation.isfrompartner = true;
  //     this.newReservation.partner = localStorage.getItem('HechRomeoAccount');
  //     this.newReservation.servicedate = new Date(
  //       this.newReservation.servicedate
  //     )
  //       .toISOString()
  //       .substring(0, 10)
  //       .split('-')
  //       .reverse()
  //       .join('/');
  //     this.newReservation.reservationdate = new Date()
  //       .toISOString()
  //       .substring(0, 10)
  //       .split('-')
  //       .reverse()
  //       .join('/');
  //     var d = new Date();
  //     var h = this.addZero(d.getHours());
  //     var m = this.addZero(d.getMinutes());
  //     this.newReservation.reservationtime = h + ':' + m;

  //     if (this.selectedLabel) {
  //       // this.newReservation.labelinfos.labelid = this.selectedLabel.id;
  //     } else {
  //       this.newReservation.labelinfos = undefined;
  //     }

  //     this.calendarService
  //       .makeReservation(this.newReservation)
  //       .subscribe((data) => {
  //         this.resetReservation();
  //         this.searchRequest();
  //       });
  //   }
  // }

  // insertCart() {
  //   let err = false;
  //   for (let element of this.newCart.items) {
  //     if (element.quantity < 1) {
  //       err = true;
  //       document
  //         .getElementById('err-' + element.serviceid)
  //         .classList.remove('d-none');
  //     } else {
  //       document
  //         .getElementById('err-' + element.serviceid)
  //         .classList.add('d-none');
  //     }
  //   }
  //   if (!err) {
  //     this.newCart.account = localStorage.getItem('HechRomeoAccount');
  //     // this.newCart.labelinfos.labelid = this.selectedLabel;
  //     this.calendarService
  //       .insertShoppingCart(this.newCart)
  //       .subscribe((data) => {
  //         this.resetCart();
  //         this.searchRequest();
  //       });
  //     document.getElementById('confirm-cart').click();
  //   }
  // }

  getAllLabels(): void {
    if (this.isUser) {
      this.labelService.getLinkedVendorLabels(this.accountService.vendor).subscribe((data) => {
        this.allLabels = data.labels;
      });
    } else {
      this.labelService.getLabels().subscribe((data) => {
        this.allLabels = data.labels;
      });
    }
  }

  getAllDepartments(): void {
    if (this.isUser) {
      this.departmentService.getLinkedVendorDepartments(this.accountService.vendor).subscribe(data => {
        this.allDepartments = data.departments;
      });
    } else {
      this.departmentService.getDepartments().subscribe((data) => {
        this.allDepartments = data.departments;
      });
    }
  }

  addZero(i) {
    if (i < 10) {
      i = '0' + i;
    }
    return i;
  }

  changeSelectedService() {
    this.newReservation.serviceid = this.selectedService.id;
    this.newReservation.decreasequantity =
      this.selectedService.decreasequantity;
    this.selectedLabel = undefined;
    if (this.selectedService.labels != null) {
      this.availableLabels = JSON.parse(
        JSON.stringify(this.selectedService.labels)
      );
      console.log('AVAILABLE LABELS', this.availableLabels);
    } else {
      this.availableLabels = [];
    }

    if (this.selectedService.isadvanced) {
      console.log('AVANZATO');

      $('#timeslots').multiselect();
      $('#timeslots').multiselect('dataprovider', []);
      if (this.newReservation.servicedate) {
        this.newReservationChangedDate();
      }
    }
  }

  addItemToCart() {
    let err = false;
    console.log('Selezionato', this.selectedService);
    if (this.selectedService.labels) {
      if (this.cartLabelsList.length == 0) {
        for (let element of this.selectedService.labels) {
          this.cartLabelsList.push(element);
        }
      } else {
        const filteredArray = this.selectedService.labels.filter(
          (value) =>
            this.cartLabelsList.filter((obj) => value.id == obj.id).length > 0
        );
        if (filteredArray.length == 0) {
          err = true;
        } else {
          this.cartLabelsList = [];
          for (let element of filteredArray) {
            this.cartLabelsList.push(element);
          }
        }
      }
    } else {
      err = true;
    }

    if (err) {
      document.getElementById('err-label').classList.remove('d-none');
    } else {
      document.getElementById('err-label').classList.add('d-none');
    }
    if (!err) {
      let newItem: CartItems = new CartItems();
      newItem.serviceid = this.selectedService.id;
      newItem.title = this.selectedService.title.it;
      this.newCart.items.push(newItem);
      this.cartServicesNotActivated = this.cartServicesNotActivated.filter(
        (obj) => obj.id != this.selectedService.id
      );
      this.selectedService = undefined;
    }

    // this.newReservation.serviceid = this.selectedService.id;
    // this.newReservation.decreasequantity = this.selectedService.decreasequantity;
    // this.selectedLabel = undefined;
    // if (this.selectedService.idlabels != null) {
    //   this.availableLabels = this.allLabels.filter(obj => {
    //     let check = false;
    //     for (let element of this.selectedService.idlabels) {
    //       if (obj.id == element) {
    //         check = true;
    //       }
    //     }
    //     return check;
    // })
    // } else {
    //   this.availableLabels = [];
    // }
  }

  getLabelName(label) {
    return this.allLabels.find((obj) => obj.id == label).name.it;
  }

  deleteItemFromCart(item) {
    this.newCart.items = this.newCart.items.filter(
      (obj) => obj.serviceid != item.serviceid
    );
    this.cartServicesNotActivated.push(
      this.cartServices.find((obj) => obj.id == item.serviceid)
    );
  }

  toggleCalendar() {
    document.getElementById('calendar-report').style.display = this.hideCalendar
      ? 'none'
      : 'block';
    document
      .getElementById('minicalendar')
      .classList.remove(!this.hideCalendar ? 'col-lg-12' : 'col-lg-4');
    document
      .getElementById('minicalendar')
      .classList.add(this.hideCalendar ? 'col-lg-12' : 'col-lg-4');
  }

  // getDataForCalendar() {
  //   // this.calendar.removeAllEvents();
  //   var notbefore = new Date(this.calendar.view.activeStart)
  //     .toISOString()
  //     .substring(0, 10)
  //     .split('-')
  //     .reverse()
  //     .join('/');
  //   var notafter = new Date(this.calendar.view.activeEnd)
  //     .toISOString()
  //     .substring(0, 10)
  //     .split('-')
  //     .reverse()
  //     .join('/');

  //   // this.getCalendar(this.account, notbefore, notafter);

  //   this.filtersComponent.filters.period.from = notbefore;
  //   this.filtersComponent.filters.period.to = notafter;
  //   this.newFilters.period.from = notbefore;
  //   this.newFilters.period.to = notafter;
  //   this.searchRequest();
  // }

  getReservationDetails(account, event) {
    let reservationids = [];
    for (let element of event.reservations) {
      reservationids.push(element.reservationid);
    }
    this.services = [];
    let searchObj = {
      account,
      serviceid: event.serviceid,
      reservationids: reservationids,
      servicedate: event.servicedate,
      servicetime: event.servicetime,
    };
    this.calendarService.getReservationDetails(searchObj).subscribe(
      (calendar) => {
        this.services = calendar;
        this.services.account = account;
        this.totalSearchRequest = 0;
        this.totalFee = 0;
        this.totalServices = 0;
        this.totalNumber = 0;

        for (let ev of this.services.reservations) {
          this.totalNumber += 1;

          if (ev.quantity) {
            this.totalServices += ev.quantity;
          } else {
            this.totalServices += 1;
          }

          let rateprice = 0.0;
          let total = ev.quantity;
          if (ev.rateprice != null && ev.rateprice != "") {
            rateprice = parseFloat(ev.rateprice);
            total++;
          }

          if (ev.amount) {
            if (!ev.isdiscount) {
              if (ev.quantity > 0) {
                this.totalFee = this.totalFee + ev.fee * total;
              } else {
                this.totalFee = this.totalFee + ev.fee;
              }
            } else {
              this.totalFee = this.totalFee + (ev.fee * (ev.amount + rateprice)) / 100;
            }
            this.totalSearchRequest = this.totalSearchRequest + ev.amount + rateprice;
          }
        }
      },
      (err) => {
        console.log('calendar daily err', err);
      }
    );
  }

  getShoppingCartDetails(account, event, advanced) {
    let reservationids = [];

    this.services = {};

    if (advanced) {
      let searchObj = {
        account,
        shoppingcartadvancedid: event.id,
      };
      this.calendarService.getAdvancedCartDetails(searchObj)
        .subscribe((calendar) => {
          this.services = calendar;
          this.services.cart = true;
          this.totalSearchRequest = 0;
          this.totalFee = 0;
          this.totalServices = 0;
          this.totalNumber = 0;
          this.services.shoppingcartdatefrom = moment(this.services.shoppingcartdatefrom).format('DD/MM/YYYY');
          this.services.shoppingcartdateto = moment(this.services.shoppingcartdateto).format('DD/MM/YYYY');

          if (!this.filtersComponent.filters.service) {
            this.totalNumber += this.services.reservations.length;

            for (const item of this.services.reservations) {
              for (const slot of item.slots) {
                if (slot.quantity) {
                  this.totalServices += slot.quantity;
                } else {
                  this.totalServices += 1;
                }
              }
            }

            let rateprice = 0.0;
            let total = this.totalServices;
            if (this.services.rateprice != null && this.services.rateprice != "") {
              rateprice = parseFloat(this.services.rateprice);
              total++;
            }

            if (this.services.amount) {
              if (!this.services.isdiscount) {
                if (total > 0) {
                  this.totalFee = this.totalFee + this.services.fee * total;
                } else {
                  this.totalFee = this.totalFee + this.services.fee;
                }
              } else {
                this.totalFee = this.totalFee + (this.services.fee * (this.services.amount + rateprice)) / 100;
              }
              this.totalSearchRequest = this.totalSearchRequest + this.services.amount + rateprice;
            } else if (rateprice > 0) {
              this.totalSearchRequest = this.totalSearchRequest + rateprice;
            }
          } else {
            for (const item of this.services.reservations) {
              if (item.serviceid === this.filtersComponent.filters.service) {
                this.totalNumber += 1;

                let rateprice = 0.0;
                let total = item.quantity;
                if (this.services.rateprice != null && this.services.rateprice != "") {
                  rateprice = parseFloat(this.services.rateprice);
                  total++;
                }

                if (this.services.amount) {
                  if (!this.services.isdiscount) {
                    if (this.services.quantity > 0) {
                      this.totalFee = this.totalFee + this.services.fee * total;
                    } else {
                      this.totalFee = this.totalFee + this.services.fee;
                    }
                  } else {
                    this.totalFee = this.totalFee + (this.services.fee * (this.services.amount + rateprice)) / 100;
                  }
                  this.totalSearchRequest = this.totalSearchRequest + this.services.amount + rateprice;
                } else if (rateprice > 0) {
                  this.totalSearchRequest = this.totalSearchRequest + rateprice;
                }

                for (const slot of item.slots) {
                  if (slot.quantity) {
                    this.totalServices += slot.quantity;
                  } else {
                    this.totalServices += 1;
                  }
                }
              }
            }
          }
        },
          (err) => {
            console.log('calendar daily err', err);
          }
        );
    } else {
      let searchObj = {
        account,
        shoppingcartid: event.id,
      };
      
      this.calendarService.getShoppingCartDetails(searchObj).subscribe(
        (calendar) => {
          this.services = calendar;
          this.services.cart = true;
          this.totalSearchRequest = 0;
          this.totalFee = 0;
          this.totalServices = 0;
          this.totalNumber = 0;

          if (!this.filtersComponent.filters.service) {
            this.totalNumber += this.services.services.length;

            let rateprice = 0.0;
            let total = this.services.services[0].quantity;
            if (this.services.rateprice != null && this.services.rateprice != "") {
              rateprice = parseFloat(this.services.rateprice);
              total++;
            }

            if (this.services.amount) {
              if (!this.services.isdiscount) {
                if (this.services.quantity > 0) {
                  this.totalFee = this.totalFee + this.services.fee * total;
                } else {
                  this.totalFee = this.totalFee + this.services.fee;
                }
              } else {
                this.totalFee = this.totalFee + (this.services.fee * (this.services.amount + rateprice)) / 100;
              }
              this.totalSearchRequest = this.totalSearchRequest + this.services.amount + rateprice;
            } else if (rateprice > 0) {
              this.totalSearchRequest = this.totalSearchRequest + rateprice;
            }

            for (let item of this.services.services) {
              if (item.quantity) {
                this.totalServices += item.quantity;
              } else {
                this.totalServices += 1;
              }
            }
          } else {
            for (let item of this.services.services) {
              if (item.serviceid === this.filtersComponent.filters.service) {
                this.totalNumber += 1;

                let rateprice = 0.0;
                let total = item.quantity;
                if (this.services.rateprice != null && this.services.rateprice != "") {
                  rateprice = parseFloat(this.services.rateprice);
                  total++;
                }

                if (this.services.amount) {
                  if (!this.services.isdiscount) {
                    if (this.services.quantity > 0) {
                      this.totalFee = this.totalFee + this.services.fee * total;
                    } else {
                      this.totalFee = this.totalFee + this.services.fee;
                    }
                  } else {
                    this.totalFee = this.totalFee + (this.services.fee * (this.services.amount + rateprice)) / 100;
                  }
                  this.totalSearchRequest = this.totalSearchRequest + this.services.amount + rateprice;
                } else if (rateprice > 0) {
                  this.totalSearchRequest = this.totalSearchRequest + rateprice;
                }

                if (item.quantity) {
                  this.totalServices += item.quantity;
                } else {
                  this.totalServices += 1;
                }
              }
            }
          }
        },
        (err) => {
          console.log('calendar daily err', err);
        }
      );
    }
  }

  selectCategory(currentObj) {
    this.clearOtherObjects(currentObj);
    if (currentObj != 3) {
      this.newCategoriesSelect['categoryObj' + (currentObj + 1)] =
        this.newCategoriesSelect['categoryObj' + currentObj].categories.find(
          (obj) =>
            obj.id == this.newCategoriesSelect['selectedCategory' + currentObj]
        );
      this.newCategoriesSelect.currentServiceList =
        this.newCategoriesSelect['categoryObj' + (currentObj + 1)].services;
    } else {
      this.newCategoriesSelect.currentServiceList = this.newCategoriesSelect[
        'categoryObj' + currentObj
      ].categories.find(
        (obj) =>
          obj.id == this.newCategoriesSelect['selectedCategory' + currentObj]
      ).services;
    }
  }

  clearOtherObjects(currentObj) {
    for (let x = currentObj + 1; x < 4; x++) {
      this.newCategoriesSelect['selectedCategory' + x] = undefined;
      this.newCategoriesSelect['categoryObj' + x] = { categories: [] };
    }
    this.newCategoriesSelect.selectedServiceInList = undefined;
    this.newCategoriesSelect.currentServiceList = [];
  }

  getAllCategories(account: string) {
    let request = {
      account: account,
      language: 'it',
    };
    this.categoriesService.publicCategoryGet(request).subscribe((data) => {
      this.chechVirtual(data.categories.categories);
      this.allCategories = data.categories.categories;
      this.categoryTree = data.categories;
      this.categoriesSelect.categoryObj0 = { ...data };
      this.newCategoriesSelect = { ...this.categoriesSelect };
      let tree = '';
      this.exporeCategories(this.allCategories, tree);
    });
  }

  chechVirtual(data) {
    let parentVendor;
    for (let element of data) {
      parentVendor = element.parentaccount;
      if (parentVendor) {
        this.virtualCategories.push(element);
      }
      this.setVirtualServices(element, parentVendor);
    }
  }

  setVirtualServices(list, parentVendor) {
    for (let element of list.services) {
      if (parentVendor) {
        element.parentaccount = parentVendor;
      }
    }
    for (let element of list.categories) {
      if (!element.parentaccount) {
        element.parentaccount = parentVendor;
      } else {
        this.virtualCategories.push(element);
      }
      this.setVirtualServices(element, element.parentaccount);
    }
  }

  exporeCategories(array, tree) {
    for (let element of array) {
      if (tree.length > 0) {
        tree = tree.concat(' > ');
      }
      tree = tree.concat(element.title.it);
      this.exporeCategories(element.categories, tree);
      for (let item of element.services) {
        item.tree = tree;
        if (
          item.deleted == false &&
          item.cartenabled == false &&
          item.visible == true &&
          item.parentaccount
        ) {
          this.allServices.push(item);
        }

        if (
          item.deleted == false &&
          item.cartenabled == true &&
          item.parentaccount
        ) {
          this.cartServices.push(item);
          this.cartServicesNotActivated.push(item);
        }
      }
      let i = tree.lastIndexOf('>');
      tree = tree.substring(0, i - 1);
    }
  }

  resetReservation() {
    this.newReservation = new Reservation();
    this.selectedService = undefined;
    this.selectedLabel = undefined;
  }
  resetCart() {
    this.newCart = new Cart();
    this.cartServicesNotActivated = [];
    for (let element of this.cartServices) {
      this.cartServicesNotActivated.push(element);
    }
    this.selectedService = undefined;
    this.selectedLabel = undefined;
    this.cartLabelsList = [];
  }

  searchRequest(event) {
    this.filtersComponent.isDetailsService = false;
    const listEventCalendar = [];

    if (this.filtersComponent.filters.type == -1 || this.filtersComponent.filters.type == undefined) {
      for (let element in event.data.report.days) {
        if (event.data.myReport.days[element]) {
          event.data.myReport.days[element] = event.data.myReport.days[element].concat(
            event.data.report.days[element]
          );
        } else {
          event.data.myReport.days[element] = event.data.report.days[element];
        }
      }
      if (!event.data.myReport.shoppingcarts.days) {
        event.data.myReport.shoppingcarts = { days: {} };
      }
      if (!event.data.report.shoppingcarts.days) {
        event.data.report.shoppingcarts = { days: {} };
      }
      for (let element in event.data.report.shoppingcarts.days) {
        if (event.data.myReport.shoppingcarts.days[element]) {
          event.data.myReport.shoppingcarts.days[element] = event.data.myReport.shoppingcarts.days[
            element
          ].concat(event.data.report.shoppingcarts.days[element]);
        } else {
          event.data.myReport.shoppingcarts.days[element] =
            event.data.report.shoppingcarts.days[element];
        }
      }

      for (let element in event.data.reportAdvanced.days) {
        if (event.data.myReportAdvanced.days[element]) {
          event.data.myReportAdvanced.days[element] = event.data.myReportAdvanced.days[element].concat(
            event.data.reportAdvanced.days[element]
          );
        } else {
          event.data.myReportAdvanced.days[element] = event.data.reportAdvanced.days[element];
        }
      }
      if (!event.data.myReportAdvanced.shoppingcarts.days) {
        event.data.myReportAdvanced.shoppingcarts = { days: {} };
      }
      if (!event.data.reportAdvanced.shoppingcarts.days) {
        event.data.reportAdvanced.shoppingcarts = { days: {} };
      }
      for (let element in event.data.reportAdvanced.shoppingcarts.days) {
        if (event.data.myReportAdvanced.shoppingcarts.days[element]) {
          event.data.myReportAdvanced.shoppingcarts.days[element] = event.data.myReportAdvanced.shoppingcarts.days[
            element
          ].concat(event.data.reportAdvanced.shoppingcarts.days[element]);
        } else {
          event.data.myReportAdvanced.shoppingcarts.days[element] =
            event.data.reportAdvanced.shoppingcarts.days[element];
        }
      }
    } else if (this.filtersComponent.filters.type == 1) {
    } else if (this.filtersComponent.filters.type == 0) {
      event.data.myReport = event.data.report;
      event.data.myReportAdvanced = event.data.reportAdvanced;
    }

    this.listSearchRequest = [];
    this.listSearchRequestShopping = [];
    this.totalSearchRequest = 0;
    this.totalFee = 0;
    this.totalServices = 0;
    this.totalNumber = 0;
    this.events = event.data.myReport.days;

    const that = this;
    Object.keys(this.events).forEach((key) => {
      // const dataevento = key.split('/').reverse().join('-');

      that.events[key].forEach((ev) => {
        const [day, month, year] = ev.servicedate.split('/');
        const oravento = ev.servicetime;

        this.totalNumber += ev.reservations.length;
        let total = 0;
        let rateprice = 0.0;
        if (ev.reservations.length > 0) {
          for (let reservation of ev.reservations) {
            if (reservation.quantity) {
              this.totalServices += reservation.quantity;
              total += reservation.quantity;
            } else {
              this.totalServices += 1;
              total += 1;
            }

            if (reservation.rateprice != null && reservation.rateprice != "")
              rateprice += parseFloat(reservation.rateprice);
          }
        }

        if (ev.amount) {
          if (ev.isdiscount) {
            let amount = ev.amount + rateprice;
            this.totalFee = this.totalFee + (ev.fee * amount) / 100;
          } else {
            if (rateprice > 0) total++;
            this.totalFee = this.totalFee + ev.fee * total;
          }

          this.totalSearchRequest = this.totalSearchRequest + ev.amount + rateprice;
        }

        let className: string;
        let status = Math.min.apply(
          null,
          ev.reservations.map((reservation) => reservation.orederstatus)
        );

        switch (status) {
          case 0:
            className = 'submitted-event';
            break;
          case 1:
            className = 'accepted-event';
            break;
          case 2:
            className = 'refused-event';
            break;
          case 3:
            className = 'worked-event';
            break;
          case 4:
            className = 'aborted-event';
            break;
        }
        // if (oravento && oravento != '') {
        if (ev.reservations[0]?.slottext) {
          let orario = ev.reservations[0].slottext[0];
          let orariosplit = orario.split("-");
          const [hours, minutes] = orariosplit[0].split(':');
          const [hoursEnd, minutesEnd] = orariosplit[1].split(':');
          const [dayEnd, monthEnd, yearEnd] = ev.serviceenddate ? ev.serviceenddate.split('/') : ev.servicedate.split('/');

          const reservation = ev.reservations[0];
          const nameLabel = reservation.name ? ` - ${reservation.name}` : '';
          const lastnameLabel = reservation.lastname || '';
          const quantityLabel = reservation.quantity ? ` ( ${reservation.quantity} )` : '';

          const subject = `<div>${ev.servicename}<small> ${nameLabel} ${lastnameLabel} ${quantityLabel} </small><div>`

          listEventCalendar.push({
            Id: ev.id,
            Subject: subject,
            StartTime: new Date(+year, +month - 1, +day, +hours, +minutes),
            EndTime: new Date(+yearEnd, +monthEnd - 1, +dayEnd, +hoursEnd, +minutesEnd),
            IsAllDay: false,
            status: Math.min.apply(null, ev.reservations.map((reservation) => reservation.orederstatus)),
            detail: ev
          });

          //   title: ,
          //   start: dataevento + 'T' + oravento,
          //   extendedProps: { ev, cart: false },
          //   // color: 'rgb(174, 202, 65)',
          //   className,
          // });
        } else {
          const [dayEnd, monthEnd, yearEnd] = ev.serviceenddate ? ev.serviceenddate.split('/') : ev.servicedate.split('/');

          if ( ev.reservations.length ) ev.reservations.forEach( reservation => {
            const nameLabel = reservation.name ? ` - ${reservation.name}` : '';
            const lastnameLabel = reservation.lastname || '';
            const quantityLabel = reservation.quantity ? ` ( ${reservation.quantity} )` : '';
            const subject = `<div>${ev.servicename}<small> ${nameLabel} ${lastnameLabel} ${quantityLabel}</small><div>`;

            listEventCalendar.push({
              Id: ev.id,
              Subject: subject,
              StartTime: new Date(+year, +month - 1, +day, 0, 0),
              EndTime: new Date(+yearEnd, +monthEnd - 1, +dayEnd, 0, 0),
              IsAllDay: true,
              status: Math.min.apply(null, ev.reservations.map((reservation) => reservation.orederstatus)),
              detail: ev
            });
            // listEventCalendar.push({
            //   title: ev.servicename,
            //   allDay: true,
            //   start: dataevento,
            //   className,
            //   extendedProps: { ev, cart: false },
            // });
          });
        }

        this.listSearchRequest.push(ev);
      });
    });

    this.events = event.data.myReport.shoppingcarts.days;
    if (this.events) {
      Object.keys(this.events).forEach((key) => {
        const dataevento = key.split('/').reverse().join('-');

        that.events[key].forEach((ev) => {
          const oravento = ev.shoppimgcarttime;

          if (!this.filtersComponent.filters.service) {
            if (ev.amount) {
              this.totalSearchRequest = this.totalSearchRequest + ev.amount;
            }

            if (ev.rateprice != null && ev.rateprice != "") {
              this.totalSearchRequest = this.totalSearchRequest + parseFloat(ev.rateprice);
            }

            if (ev.fee) {
              let amount = ev.amount;
              if (ev.rateprice != null && ev.rateprice != "")
                amount += parseFloat(ev.rateprice);
              if (ev.isdiscount) this.totalFee += (amount * ev.fee) / 100;
              else this.totalFee += ev.fee;
            }

            this.totalNumber += ev.items.length;

            for (let item of ev.items) {
              if (item.quantity) {
                this.totalServices += item.quantity;
              } else {
                this.totalServices += 1;
              }
            }
          } else {
            for (let item of ev.items) {
              if (item.serviceid === this.filtersComponent.filters.service) {
                this.totalNumber += 1;

                if (item.quantity) {
                  this.totalServices += item.quantity;
                } else {
                  this.totalServices += 1;
                }

                if (item.amount) {
                  this.totalSearchRequest += item.amount;
                }
              }
            }
          }

          let className: string;
          let status;
          // for (let element of ev.orederstatus) {
          //   if (element.orederstatus == 4) {
          //     status = 4;
          //     break;
          //   } else if (element.orederstatus == 2 || status == 2) {
          //     status = 2;
          //     continue;
          //   } else if (element.orederstatus == 0 || status == 0) {
          //     status = 0;
          //     break;
          //   } else if (element.orederstatus == 1 || status == 1) {
          //     status = 1;
          //     break;
          //   } else if (element.orederstatus == 3 || status == 3) {
          //     status = 3;
          //     break;
          //   }
          // }
          switch (ev.orederstatus) {
            case 0:
              className = 'submitted-event';
              break;
            case 1:
              className = 'accepted-event';
              break;
            case 2:
              className = 'refused-event';
              break;
            case 3:
              className = 'worked-event';
              break;
            case 4:
              className = 'aborted-event';
              break;
          }

          const [day, month, year] = ev.shoppingcartdate.split('/');
          const [hours, minutes] = ev.shoppimgcarttime.split(':');
          if (oravento && oravento != '') {
            listEventCalendar.push({
              Id: ev.id,
              Subject: 'CARRELLO',
              StartTime: new Date(+year, +month - 1, +day, +hours, +minutes),
              EndTime: new Date(+year, +month - 1, +day, +hours + 1, +minutes),
              IsAllDay: false,
              status: ev.orederstatus,
              detail: ev
            });
            // listEventCalendar.push({
            //   title: 'CARRELLO',
            //   start: dataevento + 'T' + oravento,
            //   // color: 'rgb(174, 202, 65)',
            //   className,
            //   extendedProps: { ev, cart: true },
            // });
          } else {
            listEventCalendar.push({
              Id: ev.id,
              Subject: 'CARRELLO',
              StartTime: new Date(+year, +month - 1, +day, +hours, +minutes),
              EndTime: new Date(+year, +month - 1, +day, +hours, +minutes),
              IsAllDay: true,
              status: ev.orederstatus,
              detail: ev
            });
            // listEventCalendar.push({
            //   title: 'CARRELLO',
            //   allDay: true,
            //   start: dataevento,
            //   className,
            //   extendedProps: { ev, cart: true },
            // });
          }

          this.listSearchRequestShopping.push(ev);
        });
      });
    }

    this.events = event.data.myReportAdvanced.days;

    Object.keys(this.events).forEach((key) => {
      const dataevento = key.split('/').reverse().join('-');

      that.events[key].forEach((ev) => {
        const oravento = ev.servicetime;

        this.totalNumber += ev.reservations.length;
        let total = 0;
        let rateprice = 0.0;
        if (ev.reservations.length > 0) {
          for (let reservation of ev.reservations) {
            if (reservation.quantity) {
              this.totalServices += reservation.quantity;
              total += reservation.quantity;
            } else {
              this.totalServices += 1;
              total += 1;
            }

            if (reservation.rateprice != null && reservation.rateprice != "")
              rateprice += parseFloat(reservation.rateprice);
          }
        }

        if (ev.amount) {
          if (ev.isdiscount) {
            let amount = ev.amount + rateprice;
            this.totalFee = this.totalFee + (ev.fee * amount) / 100;
          } else {
            if (rateprice > 0) total++;
            this.totalFee = this.totalFee + ev.fee * total;
          }

          this.totalSearchRequest = this.totalSearchRequest + ev.amount + rateprice;
        }

        let className: string;
        let status = Math.min.apply(
          null,
          ev.reservations.map((reservation) => reservation.orederstatus)
        );

        switch (status) {
          case 0:
            className = 'submitted-event';
            break;
          case 1:
            className = 'accepted-event';
            break;
          case 2:
            className = 'refused-event';
            break;
          case 3:
            className = 'worked-event';
            break;
          case 4:
            className = 'aborted-event';
            break;
        }
        let reservations = [];

        for (let element of ev.reservations) {
          // if (
          //   reservations.filter((obj) =>
          //     this.arraysEqual(obj.slottext, element.slottext)
          //   ).length == 0
          // ) {
            reservations.push(element);
          // }
        }

        for (let element of reservations) {
          const nameLabel = element.name ? ` - ${element.name}` : '';
          const lastnameLabel = element.lastname || '';
          const quantityLabel = element.quantity ? ` ( ${element.quantity} )` : '';
          const subject = `<div>${ev.servicename}<small> ${nameLabel} ${lastnameLabel} ${quantityLabel}</small><div>`;

          if (ev.serviceenddate) {
            let days = moment(ev.serviceenddate, 'DD/MM/YYYY').diff(
              moment(ev.servicedate, 'DD/MM/YYYY'),
              'days'
            );
            let x = 0;
            do {
              let currentDay = moment(ev.servicedate, 'DD/MM/YYYY');
              if (x > 0) {
                currentDay.add(x, 'days');
              }
              listEventCalendar.push({
                Id: ev.id,
                Subject: subject,
                StartTime: currentDay.format('YYYY-MM-DD') +
                  'T' +
                  element.slottext[0].split('-')[0],
                EndTime: this.monthView
                  ? moment(ev.serviceenddate, 'DD/MM/YYYY').format(
                      'YYYY-MM-DD'
                    ) +
                    'T' +
                    element.slottext[element.slottext.length - 1].split('-')[1]
                  : currentDay.format('YYYY-MM-DD') +
                    'T' +
                    element.slottext[element.slottext.length - 1].split('-')[1],
                IsAllDay: false,
                status: Math.min.apply(null, ev.reservations.map((reservation) => reservation.orederstatus)),
                detail: ev
              });
              // listEventCalendar.push({
              //   title: ev.servicename,
              //   start:
              //     currentDay.format('YYYY-MM-DD') +
              //     'T' +
              //     element.slottext[0].split('-')[0],
              //   end: this.monthView
              //     ? moment(ev.serviceenddate, 'DD/MM/YYYY').format(
              //         'YYYY-MM-DD'
              //       ) +
              //       'T' +
              //       element.slottext[element.slottext.length - 1].split('-')[1]
              //     : currentDay.format('YYYY-MM-DD') +
              //       'T' +
              //       element.slottext[element.slottext.length - 1].split('-')[1],
              //   extendedProps: { ev, cart: false },
              //   className,
              // });
              x++;
              if (this.monthView) {
                x = days + 1;
              }
            } while (x <= days);
          } else {
            listEventCalendar.push({
              Id: ev.id,
              Subject: subject,
              StartTime: dataevento + 'T' + element.slottext[0].split('-')[0],
              EndTime: dataevento +
                'T' +
                element.slottext[element.slottext.length - 1].split('-')[1],
              IsAllDay: false,
              status: Math.min.apply(null, ev.reservations.map((reservation) => reservation.orederstatus)),
              detail: ev
            });
            // listEventCalendar.push({
            //   title: ev.servicename,
            //   start: dataevento + 'T' + element.slottext[0].split('-')[0],
            //   end:
            //     dataevento +
            //     'T' +
            //     element.slottext[element.slottext.length - 1].split('-')[1],
            //   extendedProps: { ev, cart: false },
            //   className,
            // });
          }
        }

        // if (oravento && oravento != '') {
        //   that.calendar.addEvent({
        //     title: ev.servicename,
        //     start: dataevento + 'T' + oravento,
        //     extendedProps: { ev, cart: false },
        //     // color: 'rgb(174, 202, 65)',
        //     className,
        //   });
        // } else {
        //   that.calendar.addEvent({
        //     title: ev.servicename,
        //     allDay: true,
        //     start: dataevento,
        //     className,
        //     extendedProps: { ev, cart: false },
        //   });
        // }

        this.listSearchRequest.push(ev);
      });
    });

    this.events = event.data.myReportAdvanced.shoppingcarts.days;
    if (this.events) {
      Object.keys(this.events).forEach((key) => {
        const dataevento = key.split('/').reverse().join('-');

        that.events[key].forEach((ev) => {
          const oravento = ev.shoppimgcarttime;

          if (!this.filtersComponent.filters.service) {
            if (ev.amount) {
              this.totalSearchRequest = this.totalSearchRequest + ev.amount;
            }

            if (ev.rateprice != null && ev.rateprice != "") {
              this.totalSearchRequest = this.totalSearchRequest + parseFloat(ev.rateprice);
            }

            if (ev.fee) {
              let amount = ev.amount;
              if (ev.rateprice != null && ev.rateprice != "")
                amount += parseFloat(ev.rateprice);
              if (ev.isdiscount) this.totalFee += (amount * ev.fee) / 100;
              else this.totalFee += ev.fee;
            }

            this.totalNumber += ev.items.length;

            for (let item of ev.items) {
              if (item.quantity) {
                this.totalServices += item.quantity;
              } else {
                this.totalServices += 1;
              }
            }
          } else {
            for (let item of ev.items) {
              if (item.serviceid === this.filtersComponent.filters.service) {
                this.totalNumber += 1;

                if (item.quantity) {
                  this.totalServices += item.quantity;
                } else {
                  this.totalServices += 1;
                }

                if (item.amount) {
                  this.totalSearchRequest += item.amount;
                }
              }
            }
          }

          let className: string;
          let status;
          // for (let element of ev.orederstatus) {
          //   if (element.orederstatus == 4) {
          //     status = 4;
          //     break;
          //   } else if (element.orederstatus == 2 || status == 2) {
          //     status = 2;
          //     continue;
          //   } else if (element.orederstatus == 0 || status == 0) {
          //     status = 0;
          //     break;
          //   } else if (element.orederstatus == 1 || status == 1) {
          //     status = 1;
          //     break;
          //   } else if (element.orederstatus == 3 || status == 3) {
          //     status = 3;
          //     break;
          //   }
          // }
          switch (ev.orederstatus) {
            case 0:
              className = 'submitted-event';
              break;
            case 1:
              className = 'accepted-event';
              break;
            case 2:
              className = 'refused-event';
              break;
            case 3:
              className = 'worked-event';
              break;
            case 4:
              className = 'aborted-event';
              break;
          }

          listEventCalendar.push({
            Id: ev.id,
            Subject: 'CARRELLO AVANZATO',
            StartTime: moment(ev.shoppingcartdate, 'DD/MM/YYYY').format(
                      'YYYY-MM-DD'
                    ) +
                    'T00:00',
            EndTime: moment(ev.shoppingcartdate, 'DD/MM/YYYY').add(1, 'days').format(
                      'YYYY-MM-DD'
                    ) +
                    'T00:00',
            IsAllDay: true,
            status: ev.orederstatus,
            detail: ev
          });

          this.listSearchRequestShopping.push(ev);
        });
      });
    }

    this.isDetailsService = false;

    this.eventSettings = {
      dataSource: listEventCalendar
    };
  }

  arraysEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    for (var i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  newReservationChangedDate() {
    if (this.selectedService.isadvanced) {
      console.log(this.newReservation.servicedate);
      this.categoriesService
        .getAdvancedServiceData(
          this.selectedService.id,
          moment(this.newReservation.servicedate, 'YYYY-MM-DD').format(
            'DD/MM/YYYY'
          ),
          this.selectedService.parentaccount
        )
        .subscribe((data) => {
          this.timeslots = data.servicedata.timeslots;
          let options = [];
          for (let element of this.timeslots) {
            element.id = this.generateId();
            options.push({
              label: element.timeslottext,
              title: element.timeslottext,
              value: element.id,
            });
          }
          $('#timeslots').multiselect('dataprovider', options);
        });
    }
  }

  generateId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }

  // getCalendar(account, notbefore, notafter) {
  //   this.calendarService.getCalendar(account, notbefore, notafter).subscribe(
  //     (calendar) => {
  //       this.events = calendar;
  //       this.events = this.events.days;

  //       const that = this;
  //       Object.keys(this.events).forEach((key) => {
  //         const dataevento = key.split('/').reverse().join('-');

  //         that.events[key].forEach((ev) => {
  //           const oravento = ev.servicetime;

  //           let className: string;
  //           switch (ev.workstatus) {
  //             case 0:
  //               className = 'submitted-event';
  //               break;
  //             case 1:
  //               className = 'accepted-event';
  //               break;
  //             case 2:
  //               className = 'refused-event';
  //               break;
  //             case 3:
  //               className = 'worked-event';
  //               break;
  //             case 4:
  //               className = 'aborted-event';
  //               break;
  //           }
  //           if (oravento && oravento != '') {
  //             listEventCalendar.push({
  //               title: ev.title,
  //               start: dataevento + 'T' + oravento,
  //               // color: 'rgb(174, 202, 65)',
  //               className,
  //             });
  //           } else {
  //             listEventCalendar.push({
  //               title: ev.title,
  //               allDay: true,
  //               start: dataevento,
  //               className,
  //             });
  //           }
  //         });
  //       });
  //     },
  //     (err) => {
  //       console.log('calendar err', err);
  //     }
  //   );
  // }

  getDaily(account, notbefore, notafter) {
    this.services = [];
    this.calendarService.getDaily(account, notbefore, notafter).subscribe(
      (calendar) => {
        if (this.filter != undefined && this.filter != 'undefined') {
          for (let element of calendar.serviceReservation) {
            element.reservations = element.reservations.filter(
              (obj) => obj.orederstatus == this.filter
            );
          }

          calendar.shoppingCartList = calendar.shoppingCartList.filter(
            (obj) => obj.orederstatus == this.filter
          );
        }
        for (let element of calendar.shoppingCartList) {
          element.active = moment(
            element.shoppingcartdate,
            'DD-MM-YYYY'
          ).isSame(moment(), 'day');
        }
        this.services = calendar;
      },
      (err) => {
        console.log('calendar daily err', err);
      }
    );
  }

  // changeReservationStatus(reservation, service, cart?) {
  //   if (cart) {
  //     if (parseInt(reservation.status) == 4) {
  //       let data = {
  //         owner: this.accountService.vendor,
  //         reservationid: '',
  //         servicedate: reservation.reservationdate,
  //         servicetime: '',
  //         accountemail: reservation.email,
  //         serviceid: reservation.shoppingcartid,
  //         ordertype: 1,
  //       };
  //       this.calendarService.cancelCart(data).subscribe(() => {
  //         this.getDataForCalendar();
  //       });
  //     } else {
  //       this.calendarService
  //         .changeStatusCart(
  //           reservation.shoppingcartid,
  //           this.accountService.vendor,
  //           parseInt(reservation.status)
  //         )
  //         .subscribe(() => {
  //           this.getDataForCalendar();
  //         });
  //     }
  //   } else {
  //     if (parseInt(reservation.status) == 4) {
  //       let ordertype = 0;
  //       this.cancelReservation(
  //         reservation.reservationid,
  //         service.servicedate,
  //         service.servicetime,
  //         reservation.email,
  //         service.serviceid,
  //         ordertype
  //       );
  //     } else {
  //       let changeStatus = {
  //         account: localStorage.getItem('HechRomeoAccount'),
  //         reservationid: reservation.reservationid,
  //         servicedate: service.servicedate,
  //         servicetime: service.servicetime,
  //         serviceid: service.serviceid,
  //         workedout: reservation.workedout,
  //         orederstatus: parseInt(reservation.status),
  //       };

  //       this.calendarService
  //         .changeReservationStatus(changeStatus)
  //         .subscribe(() => {
  //           this.getDataForCalendar();
  //         });
  //     }
  //   }
  // }

  updateDaily() {
    if (this.eventSelected) {
      // this.getDaily(this.account, this.eventSelected, '');
      if (this.eventSelected.cart) {
        this.getShoppingCartDetails(this.isUser ? localStorage.getItem('HechRomeoVendor') : this.account, this.eventSelected.ev, false);
      } else {
        if (this.eventSelected.ev.shoppingcartdatefrom) {
          this.getShoppingCartDetails(this.isUser ? localStorage.getItem('HechRomeoVendor') : this.account, this.eventSelected.ev, true);
        } else {
          this.getReservationDetails(this.isUser ? localStorage.getItem('HechRomeoVendor') : this.account, this.eventSelected.ev);
        }
      }
    }
    // this.getDataForCalendar();
  }

  clearFilter() {
    this.newFilters = new Filters();
    this.newFilters.account = this.account;
    this.newCategoriesSelect = {
      selectedCategory0: undefined,
      selectedCategory1: undefined,
      selectedCategory2: undefined,
      selectedCategory3: undefined,
      categoryObj0: { categories: [] },
      categoryObj1: { categories: [] },
      categoryObj2: { categories: [] },
      categoryObj3: { categories: [] },
      currentServiceList: [],
      selectedServiceInList: undefined,
    };
    this.newFilterDate = { from: '', to: '' };
    this.newCategoriesSelect.categoryObj0 = this.categoriesSelect.categoryObj0;
    this.newCategoriesSelect.selectedServiceInList =
      this.categoriesSelect.selectedServiceInList;
  }

  clearNewFilter() {
    this.newFilters = { ...this.filters };
    this.newCategoriesSelect = { ...this.categoriesSelect };
    this.newFilterDate = { ...this.filterDate };
  }

  print(): void {
    window.print();
  }

  cancelReservation(
    reservationid,
    servicedate,
    servicetiontime,
    accountemail,
    serviceid,
    ordertype
  ) {
    this.calendarService
      .cancelReservation(
        this.account,
        reservationid,
        servicedate,
        servicetiontime,
        accountemail,
        serviceid,
        ordertype,
        false,
        ''
      )
      .subscribe(
        () => {
          // L'elenco si aggiorna una volta eliminata la prenotazione
          // this.getDaily(this.account, this.eventSelected, '');
          if (this.eventSelected.cart) {
            this.getShoppingCartDetails(this.isUser ? localStorage.getItem('HechRomeoVendor') : this.account, this.eventSelected.ev, false);
          } else {
            if (this.eventSelected.ev.shoppingcartdatefrom) {
            this.getShoppingCartDetails(this.isUser ? localStorage.getItem('HechRomeoVendor') : this.account, this.eventSelected.ev, true);
          } else {
            this.getReservationDetails(this.isUser ? localStorage.getItem('HechRomeoVendor') : this.account, this.eventSelected.ev);
          }
          }
          // this.getDataForCalendar();
        },
        (err) => {
          console.log('cancel reservation error', err);
        }
      );
  }
  setReservationToCancel(
    reservationid,
    servicedate,
    servicetime,
    email,
    serviceid
  ) {
    this.reservationToCancel.reservationid = reservationid;
    this.reservationToCancel.servicedate = servicedate;
    this.reservationToCancel.servicetime = servicetime;
    this.reservationToCancel.email = email;
    this.reservationToCancel.serviceid = serviceid;
  }

  onNavigateChange(event: any): void {
    if (event.currentDate) {
      this.filtersComponent.selectedDate = event.currentDate;
      console.log('this.selectedDate', this.filtersComponent.selectedDate)
    }

    this.filtersComponent.searchRequest();
  }

  onEventRendered(args: EventRenderedArgs): void {
    switch (args.data.status) {
      case 0:
        args.element.style.backgroundColor = '#efdba5';
        break;
      case 1:
        args.element.style.backgroundColor = '#cadb83';
        break;
      case 2:
        args.element.style.backgroundColor = '#ea9494';
        break;
      case 3:
        args.element.style.backgroundColor = '#94bbd6';
        break;
      case 4:
        args.element.style.backgroundColor = '#b7b7b7';
        break;
    }
  }

  onEventClick(args): void {
    if (!this.filtersComponent.isDetailsService || !this.filtersComponent.lastEvSelected || this.filtersComponent.lastEvSelected.id !== args.event.Id) {
      this.eventSelected = {
        ev: args.event.detail
      };

      switch (args.event.Subject) {
        case 'CARRELLO':
          this.getShoppingCartDetails(this.eventSelected.ev.vendor, this.eventSelected.ev, false);
          break;
        case 'CARRELLO AVANZATO':
          this.getShoppingCartDetails(this.eventSelected.ev.vendor, this.eventSelected.ev, true);
          break;
        default:
          this.getReservationDetails(this.eventSelected.ev.vendor, this.eventSelected.ev);
      }

      this.filtersComponent.lastEvSelected = this.eventSelected.ev;
      this.filtersComponent.isDetailsService = true;
    } else {
      this.filtersComponent.isDetailsService = false;
      this.filtersComponent.lastEvSelected = undefined;
      this.filtersComponent.searchRequest();
    }
  }

  getStatusOrder(orderstatus: number): string {
    if (orderstatus >= 0) {
      switch (orderstatus) {
        case 0:
          return 'In Attesa';
        case 1:
          return 'Accettata';
        case 2:
          return 'Rifiutata';
        case 3:
          return 'Processata';
        case 4:
          return 'Cancellata';
        default:
          return '';
      }
    } else {
      return '';
    }
  }
  reservationModalOpened() {
    this.eventsSubject.next();
  }

  getAccountCurrency() {
    this.accountService.getAccountCurrency().subscribe((data: any) => {
      this.currentCurrency = data.currency;
    });
  }

  toFloat(value: any) {
    return parseFloat(value);
  }
}
